/**
 * S-03 Underage lockout (V1 auth-profiles-gdpr) — terminal, dead serious.
 * No retry affordance, no humor, no navigation back into signup. The only
 * recourse is the SM-12 appeal path (©safety.underage_appeal, lock_ref).
 */
import { copy, formatCopy } from "@humble/shared";
import { Card } from "../../design/index.js";

const APPEAL_EMAIL = "appeal@humble.ekaii.fr";

export function UnderageLock({ lockRef }: { lockRef: string | null }) {
  return (
    <div className="auth auth--center" data-screen="S-03">
      <Card padding="lg" style={{ maxWidth: 480 }}>
        <h1 style={{ fontSize: "1.4rem", marginTop: 0 }}>You can't use Humble</h1>
        <p>{copy.safety.underage}</p>
        <p className="text-dim">
          Youth support resources:{" "}
          <a href="https://www.childhelplineinternational.org" rel="noreferrer" target="_blank">
            find your national helpline
          </a>
          .
        </p>
        <hr />
        <h2 style={{ fontSize: "1rem" }}>Adults on a shared device</h2>
        <p className="text-dim" style={{ fontSize: "0.92rem" }}>
          {formatCopy(copy.safety.underage_appeal, { lock_ref: lockRef ?? "unavailable" })}
        </p>
        <p style={{ fontSize: "0.92rem" }}>
          Appeal: <a href={`mailto:${APPEAL_EMAIL}`}>{APPEAL_EMAIL}</a>
          {lockRef ? (
            <>
              {" "}
              — reference <strong data-testid="lock-ref">{lockRef}</strong>
            </>
          ) : null}
        </p>
      </Card>
    </div>
  );
}
